import { UserManager, type UserManagerSettings } from 'oidc-client-ts';

import { type AuthConfig } from '../../store/authSlice';

const getRedirectUri = () => `${location.protocol}//${location.host}/callback`;

const getConfig = (config: AuthConfig): UserManagerSettings => ({
  authority: config.idpUrl,
  client_id: config.clientId,
  redirect_uri: getRedirectUri(),
  silent_redirect_uri: getRedirectUri(),
  response_type: 'code',
  scope: 'openid profile',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
});

const userModule = () => {
  let user: UserManager;

  const init = (config: AuthConfig) => {
    if (!user) {
      user = new UserManager(getConfig(config));
    } else {
      throw new Error('Invalid re-init of userManager');
    }
  };

  return {
    init,
    getUser: () => user,
    removeUser: () => user.removeUser(),
  };
};

export const userManager = userModule();
